import { Trans } from 'react-i18next';

import { Alert, Anchor } from '@myphx-engineering/phx-design-system';

export interface RecoverPasswordLinkErrorProps {
    onContactUsClick: () => void;
}

export const RecoverPasswordLinkError = ({
    onContactUsClick,
}: RecoverPasswordLinkErrorProps) => {
    return (
        <Alert data-testid="recover-link-error" severity="error">
            <Trans i18nKey="formErrors.recoverPasswordLinkError">
                Either the link is used already or expired or tampered with. To
                get a new link please{' '}
                <Anchor onClick={onContactUsClick}>contact us</Anchor>.
            </Trans>
        </Alert>
    );
};
